import React from 'react'

import { Helmet } from 'react-helmet'

import './frame-specific-debates.css'

const FrameSpecificDebates = (props) => {
  return (
    <div className="frame-specific-debates-container1">
      <Helmet>
        <title>FrameSpecificDebates - exported project</title>
        <meta
          property="og:title"
          content="FrameSpecificDebates - exported project"
        />
        <link
          rel="canonical"
          href="https://polipatch-copy-ycxznx.teleporthq.app/frame-specific-debates"
        />
        <meta
          property="og:url"
          content="https://polipatch-copy-ycxznx.teleporthq.app/frame-specific-debates"
        />
      </Helmet>
      <div className="frame-specific-debates-thq-frame-specific-debates-elm">
        <img
          src="/ellipse32119-c6bi-200h.png"
          alt="Ellipse32119"
          className="frame-specific-debates-thq-ellipse3-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm10">
          <img
            src="/ellipse12119-539k-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm10"
          />
          <img
            src="/ellipse22119-y615v.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm10"
          />
        </div>
        <span className="frame-specific-debates-thq-text-elm10">Volunteer</span>
        <span className="frame-specific-debates-thq-text-elm11">Articles</span>
        <span className="frame-specific-debates-thq-text-elm12">Debates</span>
        <span className="frame-specific-debates-thq-text-elm13">Sources</span>
        <span className="frame-specific-debates-thq-text-elm14">About Us</span>
        <div className="frame-specific-debates-thq-frame5-elm">
          <span className="frame-specific-debates-thq-text-elm15">Home</span>
        </div>
        <span className="frame-specific-debates-thq-text-elm16">DEBATES</span>
        <img
          src="/rectangle92119-5tnq-900w.png"
          alt="Rectangle92119"
          className="frame-specific-debates-thq-rectangle9-elm"
        />
        <span className="frame-specific-debates-thq-text-elm17">
          Specific Debate Title
        </span>
        <span className="frame-specific-debates-thq-text-elm18">
          Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
          bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
          Dignissim dictum id vestibulum felis arcu posuere. Consectetur
          pellentesque proin odio quisque risus sit quis semper dui. In pretium
          lacus risus risus commodo etiam eros sit iaculis. Dignissim quisque ut
          commodo pellentesque nisl ut pellentesque odio lectus. Mi in odio
          congue aliquam purus. Imperdiet volutpat diam commodo nunc. Eleifend
          dignissim tristique eget nulla cursus in vel urna. Vel ultrices
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="frame-specific-debates-thq-text-elm19">
          Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
          bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
          Dignissim dictum id vestibulum felis arcu posuere. Consectetur
          pellentesque proin odio quisque risus sit quis semper dui. In pretium
          lacus risus risus commodo etiam eros sit iaculis. Dignissim quisque ut
          commodo pellentesque nisl ut pellentesque odio lectus. Mi in odio
          congue aliquam purus. Imperdiet volutpat diam commodo nunc. Eleifend
          dignissim tristique eget nulla cursus in vel urna. Vel ultrices
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="frame-specific-debates-thq-text-elm20">person 2</span>
        <span className="frame-specific-debates-thq-text-elm21">person 1</span>
        <img
          src="/ellipse42119-kwbl-200h.png"
          alt="Ellipse42119"
          className="frame-specific-debates-thq-ellipse4-elm"
        />
        <img
          src="/ellipse92119-54ss-200h.png"
          alt="Ellipse92119"
          className="frame-specific-debates-thq-ellipse9-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm11">
          <img
            src="/ellipse12119-muxi-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm11"
          />
          <img
            src="/ellipse22119-9hv.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm11"
          />
        </div>
        <img
          src="/ellipse102119-7o1i-200h.png"
          alt="Ellipse102119"
          className="frame-specific-debates-thq-ellipse10-elm"
        />
        <img
          src="/ellipse112119-swri-200h.png"
          alt="Ellipse112119"
          className="frame-specific-debates-thq-ellipse11-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm12">
          <img
            src="/ellipse12119-fwyq-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm12"
          />
          <img
            src="/ellipse22119-btl.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm12"
          />
        </div>
        <img
          src="/ellipse122119-20u-200h.png"
          alt="Ellipse122119"
          className="frame-specific-debates-thq-ellipse12-elm"
        />
        <img
          src="/ellipse132119-u8nh-200h.png"
          alt="Ellipse132119"
          className="frame-specific-debates-thq-ellipse13-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm13">
          <img
            src="/ellipse12119-ho1q-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm13"
          />
          <img
            src="/ellipse22119-wehn.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm13"
          />
        </div>
        <img
          src="/ellipse142119-sdd-200h.png"
          alt="Ellipse142119"
          className="frame-specific-debates-thq-ellipse14-elm"
        />
        <img
          src="/ellipse152119-pnr8-200h.png"
          alt="Ellipse152119"
          className="frame-specific-debates-thq-ellipse15-elm"
        />
        <img
          src="/rectangle102119-6gah-900w.png"
          alt="Rectangle102119"
          className="frame-specific-debates-thq-rectangle10-elm"
        />
        <span className="frame-specific-debates-thq-text-elm22">
          Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
          bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
          Dignissim dictum id vestibulum felis arcu posuere. Consectetur
          pellentesque proin odio quisque risus sit quis semper dui. In pretium
          lacus risus risus commodo etiam eros sit iaculis. Dignissim quisque ut
          commodo pellentesque nisl ut pellentesque odio lectus. Mi in odio
          congue aliquam purus. Imperdiet volutpat diam commodo nunc. Eleifend
          dignissim tristique eget nulla cursus in vel urna. Vel ultrices
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="frame-specific-debates-thq-text-elm23">
          Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
          bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
          Dignissim dictum id vestibulum felis arcu posuere. Consectetur
          pellentesque proin odio quisque risus sit quis semper dui. In pretium
          lacus risus risus commodo etiam eros sit iaculis. Dignissim quisque ut
          commodo pellentesque nisl ut pellentesque odio lectus. Mi in odio
          congue aliquam purus. Imperdiet volutpat diam commodo nunc. Eleifend
          dignissim tristique eget nulla cursus in vel urna. Vel ultrices
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="frame-specific-debates-thq-text-elm24">person 2</span>
        <span className="frame-specific-debates-thq-text-elm25">person 1</span>
        <img
          src="/ellipse172119-f8rd-200h.png"
          alt="Ellipse172119"
          className="frame-specific-debates-thq-ellipse17-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm14">
          <img
            src="/ellipse12119-ylii-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm14"
          />
          <img
            src="/ellipse22119-3d0a.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm14"
          />
        </div>
        <img
          src="/ellipse182119-qk04-200h.png"
          alt="Ellipse182119"
          className="frame-specific-debates-thq-ellipse18-elm"
        />
        <img
          src="/ellipse192119-evqua-200h.png"
          alt="Ellipse192119"
          className="frame-specific-debates-thq-ellipse19-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm15">
          <img
            src="/ellipse12119-ycyp-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm15"
          />
          <img
            src="/ellipse22119-y8ei.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm15"
          />
        </div>
        <img
          src="/ellipse202119-llib-200h.png"
          alt="Ellipse202119"
          className="frame-specific-debates-thq-ellipse20-elm"
        />
        <img
          src="/ellipse272119-83a8-200h.png"
          alt="Ellipse272119"
          className="frame-specific-debates-thq-ellipse27-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm16">
          <img
            src="/ellipse12119-179t-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm16"
          />
          <img
            src="/ellipse22119-po1.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm16"
          />
        </div>
        <img
          src="/ellipse282119-dsz-200h.png"
          alt="Ellipse282119"
          className="frame-specific-debates-thq-ellipse28-elm"
        />
        <img
          src="/ellipse292119-qbdt-200h.png"
          alt="Ellipse292119"
          className="frame-specific-debates-thq-ellipse29-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm17">
          <img
            src="/ellipse12119-2jz9-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm17"
          />
          <img
            src="/ellipse22119-ozje.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm17"
          />
        </div>
        <span className="frame-specific-debates-thq-text-elm26">
          Lorem ipsum dolor sit amet consectetur. Nam sollicitudin etiam
          bibendum fringilla blandit. Ornare venenatis felis sit est turpis.
          Dignissim dictum id vestibulum felis arcu posuere. Consectetur
          pellentesque proin odio quisque risus sit quis semper dui. In pretium
          lacus risus risus commodo etiam eros sit iaculis. Dignissim quisque ut
          commodo pellentesque nisl ut pellentesque odio lectus. Mi in odio
          congue aliquam purus. Imperdiet volutpat diam commodo nunc. Eleifend
          dignissim tristique eget nulla cursus in vel urna. Vel ultrices
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="frame-specific-debates-thq-text-elm27">person 2</span>
        <div className="frame-specific-debates-thq-maskgroup-elm18">
          <img
            src="/ellipse12323-cctb-200h.png"
            alt="Ellipse12323"
            className="frame-specific-debates-thq-ellipse1-elm18"
          />
          <img
            src="/ellipse22323-bihyi.svg"
            alt="Ellipse22323"
            className="frame-specific-debates-thq-ellipse2-elm18"
          />
        </div>
        <img
          src="/ellipse302119-33yk-200h.png"
          alt="Ellipse302119"
          className="frame-specific-debates-thq-ellipse30-elm"
        />
        <img
          src="/ellipse232119-ymjv-200h.png"
          alt="Ellipse232119"
          className="frame-specific-debates-thq-ellipse23-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm19">
          <img
            src="/ellipse12119-wkx2-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm19"
          />
          <img
            src="/ellipse22119-pred.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm19"
          />
        </div>
        <img
          src="/ellipse242119-yt5t-200h.png"
          alt="Ellipse242119"
          className="frame-specific-debates-thq-ellipse24-elm"
        />
        <img
          src="/ellipse252119-shjtq-200h.png"
          alt="Ellipse252119"
          className="frame-specific-debates-thq-ellipse25-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm20">
          <img
            src="/ellipse12119-ak3q-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm20"
          />
          <img
            src="/ellipse22119-cyhf.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm20"
          />
        </div>
        <img
          src="/ellipse262119-nw8e-200h.png"
          alt="Ellipse262119"
          className="frame-specific-debates-thq-ellipse26-elm"
        />
        <div className="frame-specific-debates-thq-maskgroup-elm21">
          <img
            src="/ellipse12119-gjog-200h.png"
            alt="Ellipse12119"
            className="frame-specific-debates-thq-ellipse1-elm21"
          />
          <img
            src="/ellipse22119-iev9.svg"
            alt="Ellipse22119"
            className="frame-specific-debates-thq-ellipse2-elm21"
          />
        </div>
        <img
          src="/ellipse162119-2rk7-200h.png"
          alt="Ellipse162119"
          className="frame-specific-debates-thq-ellipse16-elm"
        />
        <div className="frame-specific-debates-thq-read-elm1">
          <span className="frame-specific-debates-thq-text-elm28">Report</span>
        </div>
        <div className="frame-specific-debates-thq-read-elm2">
          <span className="frame-specific-debates-thq-text-elm29">Report</span>
        </div>
        <div className="frame-specific-debates-thq-read-elm3">
          <span className="frame-specific-debates-thq-text-elm30">Report</span>
        </div>
        <div className="frame-specific-debates-thq-read-elm4">
          <span className="frame-specific-debates-thq-text-elm31">Report</span>
        </div>
        <div className="frame-specific-debates-thq-frame11-elm">
          <div className="frame-specific-debates-thq-frame12-elm"></div>
          <img
            src="/rectangle17i2290-okxf-200h.png"
            alt="Rectangle17I2290"
            className="frame-specific-debates-thq-rectangle17-elm"
          />
          <img
            src="/ellipse31i2290-7c84.svg"
            alt="Ellipse31I2290"
            className="frame-specific-debates-thq-ellipse31-elm"
          />
          <img
            src="/polygon2i2290-ikp9.svg"
            alt="Polygon2I2290"
            className="frame-specific-debates-thq-polygon2-elm"
          />
          <img
            src="/ellipse32i2290-z1zb-200h.png"
            alt="Ellipse32I2290"
            className="frame-specific-debates-thq-ellipse32-elm"
          />
          <img
            src="/ellipse33i2290-p29-200h.png"
            alt="Ellipse33I2290"
            className="frame-specific-debates-thq-ellipse33-elm"
          />
          <img
            src="/ellipse34i2290-ihsk-200h.png"
            alt="Ellipse34I2290"
            className="frame-specific-debates-thq-ellipse34-elm"
          />
        </div>
      </div>
      <a
        href="https://play.teleporthq.io/signup"
        className="frame-specific-debates-link"
      >
        <div
          aria-label="Sign up to TeleportHQ"
          className="frame-specific-debates-container2"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="frame-specific-debates-icon1"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="frame-specific-debates-text">
            Built in TeleportHQ
          </span>
        </div>
      </a>
    </div>
  )
}

export default FrameSpecificDebates
